// At-most-once execution table shared by Labs 1, 2, and 4. One entry per
// client is enough because clients issue one command at a time.
//
// table: { [clientId]: { seq, result } }
export function createAmoTable() {
  return {};
}

// Returns { status, result }. 'executed' runs apply() exactly once for a new
// sequence; 'duplicate' returns the cached result; 'stale' ignores the call.
export function amoApply(table, clientId, seq, apply) {
  const entry = table[clientId];
  if (entry && seq === entry.seq) {
    return { status: 'duplicate', result: entry.result };
  }
  if (entry && seq < entry.seq) {
    return { status: 'stale', result: undefined };
  }
  const result = apply();
  table[clientId] = { seq, result };
  return { status: 'executed', result };
}

export function amoLastSeq(table, clientId) {
  const entry = table[clientId];
  return entry ? entry.seq : 0;
}
